var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Fragment',_vm._l((_vm.node.children),function(item,index){return _c(_vm.componentName,_vm._g(_vm._b({key:item.id,tag:"comopnent",class:{
      'mod--first': index === 0,
      'mod--last': index === _vm.node.children.length - 1,
    },attrs:{"node":item}},'comopnent',_vm.$attrs,false),_vm.$listeners || {}))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }